'use strict';

function eccViewItemOnClick (e) {
    e.preventDefault();
    try {
        var productID = $(this).closest('.product').data('pid');
        var itemListProperty = $(this).closest('.js-gtm-container').data('gtmsrc');
        if (itemListProperty === 'PLP') {
            itemListProperty = getListNameFromExisistingTag(productID);
        }

        var gtmUrl = $('#gtmurl').val() + '?productlistattribute=' + encodeURIComponent(itemListProperty) + '&productID=' + productID;
        var fwdUrl = $(this).closest('.product-tile').find('.pdp-link .link').attr('href');

        $.ajax({
            url: gtmUrl,
            type: 'get',
            success: function (response) {
                try {
                    if (response.success && response.ecc_select_item !== null) {
                        dataLayer.push(response.ecc_select_item);
                    }
                } catch {
                    // Will be directed via the done function below
                }
            }
        })
        .done(function (e) {
            window.location.href = fwdUrl;
        });
    } catch {
        window.location.href = $(this).closest('.product-tile').find('.pdp-link .link').attr('href');
    }
}

function getListNameFromExisistingTag (productID) {
    var dataLayerItemListArray  = dataLayer.filter((arrayItem) => arrayItem.event === "ecc_view_item_list").map((x) => x.ecommerce.items);
    var dataLayerItemListArrayCombined = [...new Set(dataLayerItemListArray.flat(Infinity).map(JSON.stringify))].map(JSON.parse);
    return dataLayerItemListArrayCombined.filter((x) => x.item_id === String(productID))[0]["item_list_name"];
}

$(document).on('click', '.product-tile .tile-link', eccViewItemOnClick);

exports.eccViewItemOnClick = eccViewItemOnClick;
exports.getListNameFromExisistingTag = getListNameFromExisistingTag;